<bci-wk-modal class="modal">
    <content-warning (close)="close()" (accept)="hazteCliente()"></content-warning>
</bci-wk-modal>    